/* VS SILVER JEWELLERY — section behaviours (no dependencies) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header height (used by sticky bars) + scrolled state */
  function setHeaderH() {
    var g = document.getElementById('header-group');
    if (g) document.documentElement.style.setProperty('--vs-header-h', g.offsetHeight + 'px');
  }
  function onScroll() { document.body.classList.toggle('is-scrolled', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setHeaderH);

  /* Reveal on scroll */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px' }) : null;
  function initReveal(root) {
    root.querySelectorAll('.vs-reveal, .vs-strikes').forEach(function (el) {
      if (io && !reduceMotion) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* Rotating messages (announcement) and word ticker (brand statement) */
  function rotate(items, ms, useOut) {
    if (items.length < 2 || reduceMotion) return;
    var i = 0;
    setInterval(function () {
      var cur = items[i];
      i = (i + 1) % items.length;
      cur.classList.remove('is-active');
      if (useOut) { cur.classList.add('is-out'); setTimeout(function () { cur.classList.remove('is-out'); }, 600); }
      items[i].classList.add('is-active');
    }, ms);
  }
  function initRotators(root) {
    root.querySelectorAll('[data-vs-rotate]').forEach(function (wrap) {
      if (wrap.dataset.vsBound) return; wrap.dataset.vsBound = '1';
      var items = Array.prototype.slice.call(wrap.children);
      if (items[0]) items[0].classList.add('is-active');
      rotate(items, parseInt(wrap.getAttribute('data-vs-rotate'), 10) || 3500, wrap.hasAttribute('data-vs-out'));
    });
  }

  /* Shop panel (desktop mega) */
  function initPanel(root) {
    root.querySelectorAll('[data-vs-panel-toggle]').forEach(function (btn) {
      if (btn.dataset.vsBound) return; btn.dataset.vsBound = '1';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var wrap = btn.closest('.vs-header');
      var timer;
      function open() { clearTimeout(timer); panel.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      function close() { timer = setTimeout(function () { panel.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 120); }
      btn.addEventListener('click', function () { panel.classList.contains('is-open') ? close() : open(); });
      btn.addEventListener('mouseenter', open);
      btn.addEventListener('mouseleave', close);
      panel.addEventListener('mouseenter', open);
      panel.addEventListener('mouseleave', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      if (wrap) wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) close(); });
    });
  }

  /* Drawer lives inside the sticky header stacking context: move it to <body> */
  function initDrawer(root) {
    root.querySelectorAll('.vs-drawer').forEach(function (d) {
      if (d.parentNode !== document.body) {
        var old = document.body.querySelector(':scope > #' + d.id);
        if (old && old !== d) old.remove();
        document.body.appendChild(d);
      }
    });
  }

  /* Parallax on full-bleed moments */
  var parallaxEls = [];
  function initParallax(root) {
    if (reduceMotion) return;
    root.querySelectorAll('[data-vs-parallax]').forEach(function (el) { if (parallaxEls.indexOf(el) < 0) parallaxEls.push(el); });
  }
  var ticking = false;
  function runParallax() {
    ticking = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var r = el.parentNode.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
      el.style.transform = 'translate3d(0,' + (p * -12).toFixed(2) + '%,0)';
    });
  }
  window.addEventListener('scroll', function () { if (!ticking && parallaxEls.length) { ticking = true; requestAnimationFrame(runParallax); } }, { passive: true });

  /* Toast */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'vs-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<i></i><span></span>';
    toastEl.querySelector('span').textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }
  window.vsToast = toast;

  /* Demo cards: wishlist hearts + preview-only add to bag */
  var DEMO_KEY = 'vs-demo-wish';
  function demoWish() { try { return JSON.parse(localStorage.getItem(DEMO_KEY) || '[]'); } catch (e) { return []; } }
  function paintDemoWish(root) {
    var list = demoWish();
    root.querySelectorAll('[data-vs-demo-wish]').forEach(function (b) {
      b.classList.toggle('is-on', list.indexOf(b.getAttribute('data-vs-demo-wish')) > -1);
    });
  }
  /* Reviews app sections: hide the whole section (heading too) while the app has nothing to show,
     e.g. the Judge.me carousel before the first review. Product-page widgets keep their "write a review" state. */
  function checkReviewApps() {
    if (window.Shopify && Shopify.designMode) return;
    document.querySelectorAll('.vs-reviews').forEach(function (sec) {
      var app = sec.querySelector('.vs-reviews__app');
      if (!app || sec.querySelector('.vs-reviews__rail')) return;
      var h = 0;
      sec.classList.remove('is-empty'); /* measure un-hidden (same frame, no flicker) */
      app.querySelectorAll('.shopify-app-block').forEach(function (b) { h += b.offsetHeight; });
      sec.classList.toggle('is-empty', h < 40);
    });
  }
  window.addEventListener('load', function () { [800, 2500, 5000, 9000].forEach(function (t) { setTimeout(checkReviewApps, t); }); });

  /* Quick view (wishlist drawer, cart upsells): the theme's own quick view expects its old product
     layout, so we intercept its buttons and show the VS quick view section instead. */
  var qvModal;
  function qvClose() { if (qvModal) { qvModal.hidden = true; document.documentElement.style.overflow = ''; } }
  function qvOpen(url) {
    if (!qvModal) {
      qvModal = document.createElement('div');
      qvModal.className = 'vs-modal vs-qv-modal';
      qvModal.hidden = true;
      qvModal.innerHTML = '<div class="vs-modal__box vs-qv-box" role="dialog" aria-modal="true" aria-label="Quick view"><button type="button" class="vs-modal__x" data-vs-close aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div data-vs-qv-body></div></div>';
      document.body.appendChild(qvModal);
    }
    var body = qvModal.querySelector('[data-vs-qv-body]');
    body.innerHTML = '<div class="vs-qv__loading"><span></span></div>';
    qvModal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var u = url.split('?')[0];
    fetch(u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=vs-quick-view')
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var qv = doc.querySelector('[data-vs-qv]');
        if (!qv) throw new Error('no qv');
        body.innerHTML = '';
        body.appendChild(qv);
        bindQv(qv);
      })
      .catch(function () { location.href = u; });
  }
  function bindQv(qv) {
    var track = qv.querySelector('[data-vs-qv-track]');
    var dots = qv.querySelectorAll('.vs-qv__dots span');
    if (track && dots.length) track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }, { passive: true });
    qv.querySelectorAll('[data-vs-qv-variant]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        qv.querySelectorAll('[data-vs-qv-variant]').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
        var id = chip.getAttribute('data-vs-qv-variant');
        qv.querySelector('[data-vs-qv-id]').value = id;
        qv.querySelector('[data-vs-qv-add]').setAttribute('data-variant-id', id);
        qv.querySelector('[data-vs-qv-price]').textContent = chip.getAttribute('data-price');
        var was = qv.querySelector('[data-vs-qv-was]'), w = chip.getAttribute('data-was');
        was.hidden = !w; if (w) was.textContent = w;
      });
    });
    /* hand the add over to the theme cart, then get out of the way so the bag can open */
    var add = qv.querySelector('[data-vs-qv-add]');
    if (add) add.addEventListener('click', function () { setTimeout(qvClose, 60); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.btn-quick-view');
    if (!b) return;
    var src = b.hasAttribute('data-product-url') ? b : b.closest('[data-product-url]');
    var url = src && src.getAttribute('data-product-url');
    if (!url) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var oc = b.closest('.offcanvas.show');
    if (oc && window.bootstrap && bootstrap.Offcanvas) { var inst = bootstrap.Offcanvas.getInstance(oc); if (inst) inst.hide(); }
    qvOpen(url);
  }, true);

  /* Shop the look: size selects + "Add the look" (adds every piece, then opens the bag) */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-vs-look-size]');
    if (!sel) return;
    var btn = sel.form && sel.form.querySelector('.btn-atc');
    if (btn) btn.setAttribute('data-variant-id', sel.value);
  });
  document.addEventListener('click', function (e) {
    var all = e.target.closest('[data-vs-look-all]');
    if (!all) return;
    e.preventDefault();
    var look = all.closest('[data-vs-look]');
    var ids = [];
    look.querySelectorAll('[data-vs-look-form]').forEach(function (f) {
      var v = f.elements.namedItem('id');
      if (v && v.value) ids.push(v.value);
    });
    if (!ids.length) return;
    all.disabled = true;
    var last = ids.pop();
    var cartEl = document.querySelector('cart-container');
    var first = ids.length
      ? fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: +id, quantity: 1 }; }) })
        }).then(function (r) { return r.json(); })
      : Promise.resolve({});
    first.then(function (res) {
      if (res && res.status && res.description) toast(res.description);
      /* the last piece goes through the theme cart, so the bag refreshes and slides open */
      var fd = new FormData(); fd.append('id', last); fd.append('quantity', 1);
      if (cartEl && typeof cartEl.add === 'function') cartEl.add(fd);
      else return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function () { location.href = '/cart'; });
    }).catch(function () { toast('Couldn’t add the look — please try again'); })
      .then(function () { all.disabled = false; });
  });

  /* Real wishlist (theme <wishlist-button>): confirm with a toast + keep the PDP label in sync */
  function paintWishLabels(root) {
    root.querySelectorAll('.vs-pdp__actions .btn-wishlist').forEach(function (b) {
      var l = b.querySelector('.vs-wish-label');
      if (l) l.textContent = b.getAttribute('aria-pressed') === 'true' ? 'Saved to wishlist' : 'Add to wishlist';
    });
  }
  var wishClickAt = 0;
  document.addEventListener('click', function (e) {
    if (e.target.closest('wishlist-button .btn-wishlist')) wishClickAt = Date.now();
  }, true);
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      var hit = muts.filter(function (m) { return m.target.classList && m.target.classList.contains('btn-wishlist'); });
      if (!hit.length) return;
      paintWishLabels(document);
      if (Date.now() - wishClickAt < 4000) {
        wishClickAt = 0;
        toast(hit[0].target.getAttribute('aria-pressed') === 'true' ? 'Saved to your wishlist. Good taste.' : 'Removed from your wishlist');
      }
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
  }
  window.addEventListener('load', function () { setTimeout(function () { paintWishLabels(document); }, 400); });

  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-vs-demo-wish]');
    if (w) {
      e.preventDefault();
      var h = w.getAttribute('data-vs-demo-wish'), list = demoWish(), i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      try { localStorage.setItem(DEMO_KEY, JSON.stringify(list)); } catch (err) {}
      paintDemoWish(document);
      toast(i > -1 ? 'Removed from your wishlist' : 'Saved. Good taste.');
      return;
    }
    var a = e.target.closest('[data-vs-demo-add]');
    if (a) {
      e.preventDefault();
      toast((a.getAttribute('data-vs-demo-add') || 'This piece') + ' — preview only, goes live with the real product');
    }
  });

  /* Product page: gallery thumbs/qty/options/sticky bar */
  function initProduct(root) {
    root.querySelectorAll('[data-vs-product]').forEach(function (pdp) {
      if (pdp.dataset.vsBound) return; pdp.dataset.vsBound = '1';
      var qty = pdp.querySelector('[data-vs-qty] input');
      pdp.querySelectorAll('[data-vs-qty] button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
          qty.value = Math.max(1, v);
        });
      });

      var json = pdp.querySelector('[data-vs-variants]');
      var variants = json ? JSON.parse(json.textContent) : null;
      var idInput = pdp.querySelector('input[name="id"]');
      var priceEl = pdp.querySelector('[data-vs-price]');
      var btn = pdp.querySelector('[data-vs-atc]');
      function sync() {
        if (!variants) return;
        var chosen = Array.prototype.map.call(pdp.querySelectorAll('[data-vs-opt]'), function (g) {
          var c = g.querySelector('input:checked'); return c ? c.value : null;
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        pdp.querySelectorAll('[data-vs-opt-value]').forEach(function (el) {
          var i = parseInt(el.getAttribute('data-vs-opt-value'), 10); el.textContent = chosen[i] || '';
        });
        if (!v) { if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'Unavailable'; } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl && window.Shopify && Shopify.formatMoney) priceEl.textContent = Shopify.formatMoney(v.price);
        pdp.querySelectorAll('[data-vs-weight]').forEach(function (el) { if (v.weight) el.textContent = v.weight; });
        pdp.querySelectorAll('[data-vs-sku]').forEach(function (el) { if (v.sku) el.textContent = v.sku; });
        var bn = pdp.querySelector('[data-vs-buynow]'); if (bn) bn.disabled = !v.available;
        var st = document.querySelector('[data-vs-sticky]');
        if (st) {
          var sp = st.querySelector('[data-vs-sticky-price]'); if (sp && priceEl) sp.textContent = priceEl.textContent;
          var so = st.querySelector('[data-vs-sticky-opt]'); var lbl = pdp.querySelector('.vs-pdp__label-l');
          if (so && lbl) so.textContent = lbl.textContent.replace(/\s+/g, ' ').trim();
          st.querySelectorAll('[data-vs-sticky-add], [data-vs-sticky-now]').forEach(function (b) { b.disabled = !v.available; });
          var sa = st.querySelector('[data-vs-sticky-add]'); if (sa) sa.textContent = v.available ? 'Add to bag' : 'Sold out';
        }
        if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? btn.getAttribute('data-label') : 'Sold out'; }
      }
      pdp.querySelectorAll('[data-vs-opt] input').forEach(function (i) { i.addEventListener('change', sync); });

      var sticky = pdp.querySelector('[data-vs-sticky]');
      var main = pdp.querySelector('[data-vs-buy]');
      if (sticky && main && 'IntersectionObserver' in window) {
        document.body.appendChild(sticky);
        new IntersectionObserver(function (en) {
          var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        }).observe(main);
        var sAdd = sticky.querySelector('[data-vs-sticky-add]'), sNow = sticky.querySelector('[data-vs-sticky-now]');
        if (sAdd && btn) sAdd.addEventListener('click', function () { btn.click(); });
        if (sNow) sNow.addEventListener('click', function () { var m = pdp.querySelector('[data-vs-buynow], .vs-pdp__buynow'); if (m) m.click(); });
      }
    });
  }

  /* Collection preview: Shopify drops a tag that no product has yet, so filter the preview cards from the URL */
  function initCollectionDemo(root) {
    scrollActiveChip(root);
    var grid = root.querySelector('[data-vs-demo-grid]');
    if (!grid) return;
    var m = location.pathname.match(/\/collections\/[^/]+\/([^/?#]+)/);
    var tag = m ? decodeURIComponent(m[1]).toLowerCase() : '';
    if (!tag) return;
    var shown = 0;
    grid.querySelectorAll('[data-cat]').forEach(function (el) {
      var ok = el.getAttribute('data-cat') === tag || (' ' + el.getAttribute('data-flags').replace(/,/g, ' ') + ' ').indexOf(' ' + tag + ' ') > -1;
      el.hidden = !ok; if (ok) shown++;
    });
    var empty = root.querySelector('[data-vs-demo-empty]');
    if (empty) empty.hidden = shown > 0;
    var intros = {};
    try { intros = JSON.parse(root.querySelector('[data-vs-intros]').textContent); } catch (e) {}
    var t = root.querySelector('[data-vs-col-title]'), p = root.querySelector('[data-vs-col-text]');
    if (intros[tag]) {
      if (t) t.innerHTML = intros[tag].title;
      if (p) p.textContent = intros[tag].text;
      document.title = t.textContent + ' – ' + document.title.split('–').pop().trim();
    }
    root.querySelectorAll('.vs-col__chip').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-tag') === tag); });
    scrollActiveChip(root);
  }
  function scrollActiveChip(root) {
    var a = root.querySelector('.vs-col__chip.is-active');
    if (a) { var bar = a.parentNode; bar.scrollLeft = a.offsetLeft - (bar.clientWidth - a.offsetWidth) / 2; }
  }

  /* Hero carousel: autoplay, progress bars, arrows, swipe, pause on hover/hidden tab */
  function initHero(root) {
    root.querySelectorAll('[data-vs-hero]').forEach(function (hero) {
      if (hero.dataset.vsBound) return; hero.dataset.vsBound = '1';
      var slides = hero.querySelectorAll('.vs-hero__slide'), bars = hero.querySelectorAll('.vs-hero__bar');
      var nowEl = hero.querySelector('[data-vs-hero-now]');
      var ms = (parseInt(hero.getAttribute('data-autoplay'), 10) || 6) * 1000, cur = 0, timer, paused = false;
      hero.style.setProperty('--dur', ms / 1000 + 's');
      if (slides.length < 2) return;
      function go(n) {
        n = (n + slides.length) % slides.length;
        slides[cur].classList.remove('is-active');
        slides[n].classList.add('is-active');
        bars.forEach(function (b, i) { b.classList.remove('is-active'); b.classList.toggle('is-done', i < n); });
        void hero.offsetWidth;
        if (bars[n]) bars[n].classList.add('is-active');
        if (nowEl) nowEl.textContent = ('0' + (n + 1)).slice(-2);
        slides[n].querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
        var nx = slides[(n + 1) % slides.length];
        if (nx) nx.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
        cur = n; schedule();
      }
      function schedule() { clearTimeout(timer); if (!paused && !reduceMotion) timer = setTimeout(function () { go(cur + 1); }, ms); }
      function pause(p) { paused = p; hero.classList.toggle('is-paused', p); if (p) clearTimeout(timer); else schedule(); }
      hero.querySelectorAll('[data-go]').forEach(function (b) { b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-go'), 10)); }); });
      hero.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
      if (window.matchMedia('(hover: hover)').matches) {
        hero.addEventListener('mouseenter', function () { pause(true); });
        hero.addEventListener('mouseleave', function () { pause(false); });
      }
      document.addEventListener('visibilitychange', function () { pause(document.hidden); });
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
      });
      if (bars[0]) bars[0].classList.add('is-active');
      schedule();
    });
  }

  /* Scroll reveal: 0 -> 1 progress while the tall section scrolls past its sticky frame */
  var unveils = [];
  function initUnveil(root) { root.querySelectorAll('[data-vs-unveil]').forEach(function (u) { if (unveils.indexOf(u) < 0) unveils.push(u); }); runUnveil(); }
  function runUnveil() {
    var vh = window.innerHeight;
    unveils.forEach(function (u) {
      var r = u.getBoundingClientRect(), span = r.height - vh;
      var p = span > 0 ? Math.min(1, Math.max(0, -r.top / (span * 0.85))) : 1;
      u.style.setProperty('--p', p.toFixed(3));
    });
  }
  var uTick = false;
  window.addEventListener('scroll', function () { if (!uTick && unveils.length) { uTick = true; requestAnimationFrame(function () { uTick = false; runUnveil(); }); } }, { passive: true });
  window.addEventListener('resize', runUnveil);

  /* Shop the look: dots <-> list */
  function initLook(root) {
    root.querySelectorAll('[data-vs-look]').forEach(function (look) {
      if (look.dataset.vsBound) return; look.dataset.vsBound = '1';
      var list = look.querySelector('[data-vs-look-list]');
      function isCarousel() { return list && list.scrollWidth > list.clientWidth + 4; }
      function set(n, scroll) {
        look.querySelectorAll('[data-look]').forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-look') === n); });
        look.querySelectorAll('[data-look-item]').forEach(function (i) { i.classList.toggle('is-active', i.getAttribute('data-look-item') === n); });
        /* Mobile: the products are a carousel under the image — bring the tapped piece into view */
        if (scroll && isCarousel()) {
          var item = list.querySelector('[data-look-item="' + n + '"]');
          if (item) list.scrollTo({ left: list.scrollLeft + item.getBoundingClientRect().left - list.getBoundingClientRect().left - parseFloat(getComputedStyle(list).paddingLeft || 0), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
      look.querySelectorAll('[data-look]').forEach(function (d) { d.addEventListener('click', function () { set(d.getAttribute('data-look'), true); }); d.addEventListener('mouseenter', function () { if (!isCarousel()) set(d.getAttribute('data-look')); }); });
      /* Mobile: swiping the carousel highlights the matching dot on the image */
      if (list && 'IntersectionObserver' in window) {
        var lio = new IntersectionObserver(function (en) {
          if (!isCarousel()) return;
          en.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) set(e.target.getAttribute('data-look-item')); });
        }, { root: list, threshold: [0.6] });
        list.querySelectorAll('[data-look-item]').forEach(function (i) { lio.observe(i); });
      }
      look.querySelectorAll('[data-look-item]').forEach(function (i) { i.addEventListener('mouseenter', function () { set(i.getAttribute('data-look-item')); }); });
    });
  }

  /* Product page extras: copy code, gift note, delivery estimate, share, modals */
  function initPdpExtras(root) {
    root.querySelectorAll('[data-vs-copy]').forEach(function (b) {
      if (b.dataset.vsBound) return; b.dataset.vsBound = '1';
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-vs-copy');
        try { navigator.clipboard.writeText(code); } catch (e) {}
        toast('Code ' + code + ' copied — use it at checkout');
      });
    });
    root.querySelectorAll('[data-vs-gift-toggle]').forEach(function (c) {
      if (c.dataset.vsBound) return; c.dataset.vsBound = '1';
      c.addEventListener('change', function () {
        var box = c.closest('.vs-pdp__info').querySelector('[data-vs-gift]');
        if (box) { box.hidden = !c.checked; if (c.checked) { var t = box.querySelector('textarea'); if (t) t.focus(); } }
      });
    });
    root.querySelectorAll('[data-vs-eta]').forEach(function (el) {
      var pdp = el.closest('[data-vs-product]');
      var cutoff = parseInt(pdp.getAttribute('data-cutoff'), 10) || 16;
      var dMin = parseInt(pdp.getAttribute('data-days-min'), 10) || 3, dMax = parseInt(pdp.getAttribute('data-days-max'), 10) || 5;
      function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; }
      function paint() {
        var now = new Date(), cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
        var ship = new Date(now);
        if (now >= cut || now.getDay() === 0) { ship = addBiz(now, 1); cut = new Date(ship); cut.setHours(cutoff, 0, 0, 0); }
        var left = Math.max(0, cut - now), h = Math.floor(left / 36e5), m = Math.floor(left % 36e5 / 6e4);
        var fmt = { weekday: 'short', day: 'numeric', month: 'short' };
        var a = addBiz(ship, dMin).toLocaleDateString('en-IN', fmt), b = addBiz(ship, dMax).toLocaleDateString('en-IN', fmt);
        el.querySelector('[data-vs-eta-left]').textContent = (h > 23 ? Math.floor(h / 24) + 'd ' + (h % 24) + 'h' : h + 'h ' + m + 'm');
        el.querySelector('[data-vs-eta-date]').textContent = a + ' – ' + b;
      }
      paint(); setInterval(paint, 60000);
    });
    root.querySelectorAll('[data-vs-share]').forEach(function (b) {
      if (b.dataset.vsBound) return; b.dataset.vsBound = '1';
      b.addEventListener('click', function () {
        var data = { title: b.getAttribute('data-vs-share'), url: location.href };
        if (navigator.share) navigator.share(data).catch(function () {});
        else { try { navigator.clipboard.writeText(location.href); } catch (e) {} toast('Link copied — send it to someone who gets it'); }
      });
    });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-vs-open]');
    if (o) { var m = document.querySelector(o.getAttribute('data-vs-open')); if (m) { if (m.parentNode !== document.body) document.body.appendChild(m); m.hidden = false; document.documentElement.style.overflow = 'hidden'; } return; }
    var m2 = e.target.closest('.vs-modal');
    if (m2 && (e.target === m2 || e.target.closest('[data-vs-close]'))) { m2.hidden = true; document.documentElement.style.overflow = ''; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('.vs-modal:not([hidden])').forEach(function (m) { m.hidden = true; document.documentElement.style.overflow = ''; }); });

  /* Welcome popup: once per N days, after a delay; never on cart/checkout-ish pages */
  function initPopup() {
    var pop = document.querySelector('[data-vs-popup]');
    if (!pop || /\/(cart|account)/.test(location.pathname)) return;
    var key = 'vs-popup-seen', days = parseInt(pop.getAttribute('data-days'), 10) || 7;
    var posted = pop.querySelector('.vs-form__ok');
    if (posted) { pop.hidden = false; return; }
    try { var t = parseInt(localStorage.getItem(key), 10); if (t && Date.now() - t < days * 864e5) return; } catch (e) {}
    setTimeout(function () {
      if (document.querySelector('.offcanvas.show, .offcanvas.showing, .modal.show, .vs-modal:not([hidden])')) return;
      document.body.appendChild(pop); pop.hidden = false;
      try { localStorage.setItem(key, Date.now()); } catch (e) {}
    }, (parseInt(pop.getAttribute('data-delay'), 10) || 12) * 1000);
  }

  /* Hide zero-count badges in the header (theme scripts fill them with "0") */
  function paintBadges() {
    document.querySelectorAll('.vs-header .wishlist-count-badge, .vs-header .cart-count-badge').forEach(function (b) {
      b.classList.toggle('is-zero', b.textContent.trim() === '' || b.textContent.trim() === '0');
    });
  }
  if ('MutationObserver' in window) {
    var bq = false;
    new MutationObserver(function () { if (!bq) { bq = true; requestAnimationFrame(function () { bq = false; paintBadges(); }); } }).observe(document.body || document.documentElement, { childList: true, subtree: true, characterData: true });
    setTimeout(paintBadges, 0);
  }

  /* Shoppable reels: play muted when in view, tap for sound, arrows scroll */
  function initReels(root) {
    root.querySelectorAll('[data-vs-reels]').forEach(function (sec) {
      if (sec.dataset.vsBound) return; sec.dataset.vsBound = '1';
      var rail = sec.querySelector('[data-vs-reels-rail]');
      sec.querySelectorAll('[data-vs-reels-dir]').forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: parseInt(b.getAttribute('data-vs-reels-dir'), 10) * rail.clientWidth * 0.8, behavior: 'smooth' }); });
      });
      var vids = sec.querySelectorAll('.vs-reel video');
      function load(v) { if (v.dataset.src && !v.src) { v.src = v.dataset.src; } }
      function play(v) { load(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); v.closest('.vs-reel').classList.add('is-playing'); }
      function stop(v) { v.pause(); v.closest('.vs-reel').classList.remove('is-playing'); }
      if ('IntersectionObserver' in window && !reduceMotion) {
        var io2 = new IntersectionObserver(function (en) { en.forEach(function (e) { e.isIntersecting && e.intersectionRatio > 0.6 ? play(e.target) : stop(e.target); }); }, { threshold: [0, 0.6, 1] });
        vids.forEach(function (v) { v.muted = true; io2.observe(v); });
      }
      sec.querySelectorAll('[data-vs-reel]').forEach(function (m) {
        m.addEventListener('click', function (e) {
          var v = m.querySelector('video'); if (!v) return;
          var card = m.closest('.vs-reel');
          if (e.target.closest('[data-vs-reel-sound]') || !v.paused) {
            var on = v.muted;
            vids.forEach(function (o) { o.muted = true; o.closest('.vs-reel').classList.remove('is-sound'); });
            v.muted = !on; card.classList.toggle('is-sound', on); if (v.paused) play(v);
          } else { play(v); }
        });
      });
    });
  }

  /* Buy it now (real products): add the selected variant, then go straight to checkout */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vs-buynow]');
    if (!b) return;
    e.preventDefault();
    var form = document.getElementById('vs-pdp-form');
    if (!form) return;
    b.disabled = true; b.classList.add('is-loading');
    fetch((window.Shopify && Shopify.routes && Shopify.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; window.location.href = '/checkout'; })
      .catch(function () { b.disabled = false; b.classList.remove('is-loading'); toast('Sorry — that piece couldn’t be added. Please try again.'); });
  });

  /* Pincode: validate an Indian 6-digit pincode and show the estimated delivery window */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-vs-pin]');
    if (!f) return;
    e.preventDefault();
    var box = f.closest('[data-vs-eta]'), msg = box.querySelector('[data-vs-pin-msg]'), v = f.querySelector('input').value.trim();
    msg.hidden = false;
    if (!/^[1-9][0-9]{5}$/.test(v)) { msg.className = 'vs-pdp__pin-msg is-error'; msg.textContent = 'Please enter a valid 6-digit pincode.'; return; }
    var date = box.querySelector('[data-vs-eta-date]').textContent;
    msg.className = 'vs-pdp__pin-msg is-ok';
    msg.textContent = 'Delivering to ' + v + ' — estimated ' + date + '. Exact timelines are confirmed at checkout.';
    try { localStorage.setItem('vs-pin', v); } catch (err) {}
  });
  function initPin(root) {
    var saved; try { saved = localStorage.getItem('vs-pin'); } catch (e) {}
    root.querySelectorAll('[data-vs-pin] input').forEach(function (i) {
      i.addEventListener('input', function () { i.value = i.value.replace(/\D/g, '').slice(0, 6); });
      if (saved && !i.value) i.value = saved;
    });
  }

  /* Product image zoom */
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-vs-zoom]');
    if (!z) return;
    var m = document.getElementById('vs-zoom'); if (!m) return;
    if (m.parentNode !== document.body) document.body.appendChild(m);
    m.querySelector('[data-vs-zoom-img]').src = z.getAttribute('data-vs-zoom');
    m.hidden = false; document.documentElement.style.overflow = 'hidden';
  });

  /* PDP (desktop): make whichever column is shorter sticky. If that column is taller than the
     screen, it scrolls until its bottom is visible and then sticks (top = viewport - height). */
  function initPdpSticky(root) {
    root.querySelectorAll('.vs-pdp__grid').forEach(function (grid) {
      if (grid.dataset.vsSticky) return; grid.dataset.vsSticky = '1';
      var gal = grid.querySelector('.vs-pdp__gallery'), info = grid.querySelector('.vs-pdp__info');
      if (!gal || !info) return;
      var mq = window.matchMedia('(min-width: 990px)');
      function update() {
        [gal, info].forEach(function (el) { el.classList.remove('is-sticky'); el.style.removeProperty('--vs-stick-top'); });
        if (!mq.matches) return;
        var gh = gal.offsetHeight, ih = info.offsetHeight;
        if (Math.abs(gh - ih) < 40) return;
        var el = gh < ih ? gal : info, h = el.offsetHeight;
        var headerH = document.getElementById('header-group') ? document.getElementById('header-group').offsetHeight : 100;
        var gap = 24, top = headerH + gap;
        if (h + top + gap > window.innerHeight) top = window.innerHeight - h - gap;
        el.style.setProperty('--vs-stick-top', top + 'px');
        el.classList.add('is-sticky');
      }
      update();
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      if ('ResizeObserver' in window) { var ro = new ResizeObserver(function () { clearTimeout(grid._vsT); grid._vsT = setTimeout(update, 60); }); ro.observe(gal); ro.observe(info); }
      grid.querySelectorAll('img').forEach(function (i) { if (!i.complete) i.addEventListener('load', update, { once: true }); });
    });
  }

  /* Newsletter feedback */
  function initNews(root) {
    root.querySelectorAll('[data-vs-news]').forEach(function (f) {
      if (f.dataset.vsBound) return; f.dataset.vsBound = '1';
      f.addEventListener('submit', function () { f.classList.add('is-sending'); });
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root); initRotators(root); initPanel(root); initDrawer(root);
    initParallax(root); paintDemoWish(root); initProduct(root); initNews(root); initCollectionDemo(root); initHero(root); initUnveil(root); initLook(root); initPdpExtras(root); initReels(root); initPin(root); initPdpSticky(root);
    setHeaderH(); runParallax();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); onScroll(); initPopup(); });
  else { init(); onScroll(); initPopup(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
